export const ROUTES = {
    DEPARTMENT_LIST: '/api/v1/department/list',
    DEPARTMENT_USER_LIST: 'api/v1/list/user',
    DEPARTMENT_CREATE: '/api/v1/department/create',
    DEPARTMENT_UPDATE: (id) => `/api/v1/department/update/${id}`,
    DEPARTMENT_DELETE: '/api/v1/department/delete',
    DEPARTMENT_VIEW: (id) => `api/v1/department/view/${id}`,
}
